export const Hosting = (props) => {
  return (
    <div id="hosting" className='text-center'>
      <div className="container">
      <div className='section-title'>
          <h2>{props.data ? props.data.title : 'Loading'}</h2>
          <p>{props.data ? props.data.paragraph : 'Loading'}</p>
        </div>

        
          <div class="pricing-table">
        <div class="plan">
            <h2>Basic</h2>
            <p class="price">$24.990 / año</p>
            <ul class="features">
                <li>5 gb de espacio</li>
                <li>1 Cuenta de Correo</li>
                <li>Instalación WordPress 1 Click</li>
                <li>Protección anti DDOS</li>
                <li>Soporte Whatsapp 24HRS</li>
                <li> Backup Manual</li>
            </ul>
            <a href="https://hosting.prms.cl/finalizar-compra/?add-to-cart=140" class="btn">Contratar</a>
        </div>
        <div class="plan">
            <h2>Standard</h2>
            <p class="price">$39.990 / año</p>
            <ul class="features">
                <li>15 gb de espacio</li>
                <li>5 Cuentas de Correo</li>
                <li>Instalación WordPress 1 Click</li>
                <li>Protección anti DDOS</li>
                <li>Atención prioritaria 4 horas</li>
                <li>Backup Diario (7 días)</li>
             
            </ul>
            <a href="https://hosting.prms.cl/finalizar-compra/?add-to-cart=143" class="btn">Contratar</a>
        </div>
        <div class="plan">
            <h2>Premium</h2>
            <p class="price">$59.900 /month</p>
            <ul class="features">
                <li>30 gb de espacio</li>
                <li>10 Cuentas de Correo</li>
                <li>Instalación WordPress 1 Click</li>
                <li>Protección anti DDos</li>
                <li>Soporte Vip 1 Hora</li>
                <li>Backups Diario (30 Días)</li>
            </ul>
            <a href="https://hosting.prms.cl/finalizar-compra/?add-to-cart=145" class="btn">Contratar</a>
        </div>
    </div>
        </div>
      </div>
    
  );
};
